import isMobile from 'ismobilejs';
import computedStyle from '../utils/computedStyle';
import listener from '../utils/listener';

function checkIsMobile() {
  return isMobile(window.navigator).any && $(window).innerWidth() <= parseInt(computedStyle.get('--breakpoint-lg'));
}

export default class ClientUtils {
  init() {
    // Only on mobile - Add a spinner when clicking on the logo
    $('body').on('click', '.logo-home', function (e) {
      const isMobile = checkIsMobile();
      if (isMobile) {
        $.spinner().start();
      }
    });

    // Listen for login event to track on Analytics
    this.trackLoginEvent();
  }

  trackLoginEvent() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('loginEvent') === '1' && urlParams.get('loginUid')) {
      listener.dataLayerLoginHandler(urlParams.get('loginUid'));
      urlParams.delete('loginEvent');
      urlParams.delete('loginUid');
      const cleanUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;
      window.history.replaceState(null, '', cleanUrl);
    }
  }
}
